import functions from './functions.js';

$(function () {
    let $tracking = $('[data-gatracking]');

    if ($tracking.length)
    {
        window.dataLayer = window.dataLayer || [];

        let trackingData = $('[data-gatracking]');
        if (trackingData.length)
        {
            trackingData.each(function(index, elem) {
                let data = JSON.parse( $(elem).attr('data-gatracking'));
                let id = $(elem).attr('data-gaid') || false;
                if ( id && functions.getCookie(id)) return;

                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(data);

                id && functions.setCookie(id, 'sent');
            });

        }

    }
});